module.exports = __webpack_public_path__ + "static/img/10001 (1).818e3c9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (1).webp
// module id = zKh+
// module chunks = 14